import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { textStyles } from '../../theme';
export default {
  container: {},
  wrapper: {
    maxWidth: function maxWidth(props) {
      var _props$theme;
      return "".concat((props == null ? void 0 : (_props$theme = props.theme) == null ? void 0 : _props$theme.maxWidth) / 10, "rem") || 'none';
    },
    marginLeft: 'auto',
    marginRight: 'auto',
    textAlign: function textAlign(props) {
      var _props$theme2;
      return (props == null ? void 0 : (_props$theme2 = props.theme) == null ? void 0 : _props$theme2.paragraphTextAlign) || 'justify';
    },
    textJustify: 'inter-character'
  },
  text: _objectSpread(_objectSpread({}, textStyles.text), {}, {
    '& a, & a:visited, & a:active': {
      textDecoration: 'underline'
    },
    '& a:hover': {
      textDecoration: 'none'
    },
    '& strong': {
      fontWeight: 'bold'
    },
    '& > *': {
      margin: 0
    },
    '& > * + *': {
      marginTop: '1rem'
    },
    '& h1': _objectSpread(_objectSpread({}, textStyles.h1), {}, {
      textAlign: 'center'
    }),
    '& h2, & h3, & h4, & h5': _objectSpread({}, textStyles.h3),
    '& > h1:not(:first-child), & > h2:not(:first-child), & > h3:not(:first-child), & > h4:not(:first-child), & > h5:not(:first-child)': {
      marginTop: '2.5rem'
    },
    '& > h1 + *': {
      marginTop: '2.5rem'
    },
    '& > h2 + *, & > h3 + *, & > h4 + *, & > h5 + *': {
      marginTop: '1rem'
    },
    '& li': {
      position: 'relative'
    },
    '& ol': {
      '& > * + *': {
        marginTop: '1rem'
      }
    },
    '& ol > li': {
      paddingLeft: '20px',
      counterIncrement: 'list-number',
      '&::before': {
        content: 'counter(list-number) ". "',
        position: 'absolute',
        top: 0,
        left: 0
      },
      '& > p:not(:first-child)': {
        marginTop: '1rem'
      }
    },
    '& ul': {
      '& > * + *': {
        marginTop: '0.5rem'
      }
    },
    '& ul > li': {
      '&::before': {
        content: '"-"',
        marginRight: '0.5rem'
      },
      '& > p:not(:first-child)': {
        marginTop: '1rem'
      }
    },
    '& li li': {
      marginLeft: '1rem'
    }
  })
};